import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import {
  LotService,
  AuthenticationService,
  AuctionService,
  WatchListService,
  CmsService,
  WebStorageService,
} from '../../../../services';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { debounceTime } from 'rxjs/operators';
import routeTable from '../../../../utility/routeTable';
import { ToastrService } from 'ngx-toastr';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import constants from '../../../../utility/constants';
import {
  LotPublic,
  AuctionCurrentState,
  BulkBidSubmissionResult,
} from '../../../../models';
import { BidService, BulkBid } from '../../../../services/bid.service';
import { AuctionAnnouncementService } from '../../../../services/auction-announcement.service';
import { environment } from '../../../../../environments/environment';
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from '@microsoft/signalr';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-auction-lot-catalog',
  templateUrl: './auction-lot-catalog.component.html',
  styleUrls: ['./auction-lot-catalog.component.css'],
})
export class AuctionLotCatalogComponent implements OnInit {
  displayedColumns: string[] = [
    'lotNum',
    'lotDes',
    'currentAmount',
    'newBidAmount',
    'delete',
  ];
  showListView = true;
  auctionDetail: any;
  showMore = false;

  // for filters
  lotTypes = 1; // 1 for 'All'
  locations = '';
  categories = '';
  searchTerm = '';
  pageNumber = 1;
  pageSize: number;
  pageSizes: Array<number> = [20, 50, 100];
  sortBy = '';
  sortOrder = '';
  isPaginated = true;
  onlyActive = false;

  // currentUserLogin
  loggedInUser = 0;

  // auction lot data
  auctionLotData: Array<LotPublic>;
  totalAuctionLots: number;

  // for dropdowns
  lotTypesData: any;
  lotCategoriesData: any;
  lotLocationData: any;
  submitBidError: string;

  changeInSelectedBulkLots: boolean = false;

  isLoggedIn: boolean | null;
  responseData: any;
  helpTextData: string;
  modalRef: BsModalRef;
  searchControl = new FormControl();
  isSold: boolean = false;
  auctionCode: string;
  isLoading: boolean = false;
  helpTexts = constants.common.helpText;
  cmsPages = constants.common.cmsPages;

  showListing: boolean = true;
  showFeaturedLots: boolean = true;

  selectedLotsForBulk: Array<LotPublic> = [];
  showBulkSubmitBtn: boolean = true;
  userPaddleNumber: string;
  userFullName: string;
  bulkBidSubmissionResult: Array<BulkBidSubmissionResult>;
  isBulkBid: boolean;
  @ViewChild('reviewModal', { static: false }) reviewModal: TemplateRef<any>;
  featuredLotInfo = null;
  auctionCurrentState: AuctionCurrentState;
  readOnlyCatalog: boolean;
  isUnpublishedLotNeeded: boolean = false;
  private subscriptions: Array<Subscription> = [];

  auctionAnnouncement: string;

  numberOfminLotRequiredForBulkBid = 1;
  private removedLotsFromBulkLot: LotPublic[] = [];
  auctionStatuses = constants.common.auctionStatus;

  // all socket related variables/properites
  private lotHubConnection: HubConnection;
  private hubUrl: string = environment.serverUrl + environment.hubs.bid;
  loader: boolean = false;
  isConnectionClosing: boolean = false;
  isLotClosed: boolean = false;
  public isLotConnected: boolean = false;
  public sendLotDataToLotCard = null;
  public sendLotWatcherDataToLotCard = null;
  public sendTimerToLotCard = null;
  private serverTimeSubcription: Subscription;
  public isLowConnectionMode: boolean = false;

  constructor(
    private storage: WebStorageService,
    private auctionService: AuctionService,
    private authenticationService: AuthenticationService,
    private lotService: LotService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private watchListService: WatchListService,
    private bidService: BidService,
    private announcementService: AuctionAnnouncementService,
    private cmsService: CmsService
  ) {
    this.isLoggedIn = this.authenticationService.checkLoggedIn();
    let pageSize = storage.storage.get('buyer-lot-catalog-page-size');
    if (pageSize) {
      this.pageSize = +pageSize;
    } else {
      this.pageSize = constants.public.lotPageSize;
    }
  }

  ngOnInit(): void {
    this.route.fragment.subscribe((frag) => {
      if (frag === 'check') {
        this.isUnpublishedLotNeeded = true;
      }
    });

    this.route.queryParams.subscribe((qParams) => {
      const lotTypes = qParams['type'];
      const locations = qParams['loc'];
      const categories = qParams['cat'];
      const searchTerm = qParams['term'];
      const pageNumber = qParams['page'];
      const sortBy = qParams['sort'];
      const sortOrder = qParams['order'];
      const featured = qParams['featured'];

      if (lotTypes !== null) {
        this.lotTypes = +lotTypes;
      }
      if (locations !== null) {
        this.locations = locations;
      }
      if (categories !== null) {
        this.categories = categories;
      }
      //if (searchTerm) {
      this.searchTerm = searchTerm;
      //}
      if (sortBy) {
        this.sortBy = sortBy;
      }
      if (sortOrder) {
        this.sortOrder = sortOrder;
      }
      if (featured) {
        this.showFeaturedLots = featured === 'true';
      }

      if (pageNumber) {
        this.pageNumber = +pageNumber;
      } else {
        this.pageNumber = 1;
      }

      if (
        lotTypes !== null ||
        locations !== null ||
        categories !== null ||
        searchTerm ||
        pageNumber ||
        sortBy ||
        sortOrder ||
        featured
      ) {
        this.getAuctionsLotData();
      }
    });

    this.route.params.subscribe((params) => {
      this.auctionCode = params['auctionCode'];
    });

    var loggedInData = this.authenticationService.checkLoggedIn();
    if (loggedInData) {
      let userData = this.authenticationService.currentBuyerValue()?.user;
      this.loggedInUser = userData?.id;
      this.userFullName = userData?.firstName + ' ' + userData?.lastName;
    }
    this.getResolverData();
    this.getAuctionAnnouncement();

    var loggedInData = this.storage.getBuyer()?.loggedIn;
    if (loggedInData == true) {
      this.loggedInUser = this.storage.getBuyer()?.currentUser?.user?.id;
    }
  }

  private checkLotConnectionMode() {
    let storedValue = this.storage.getBuyer();
    if (storedValue)
      this.isLowConnectionMode = storedValue?.lotLowConnectionMode;

    if (!this.isLowConnectionMode) {
      if (
        this.loggedInUser > 0 &&
        this.auctionDetail.auctionStatus == this.auctionStatuses.live &&
        !this.readOnlyCatalog
      ) {
        this.buildConnection();
      }
    }
  }

  getResolverData() {
    this.route.data.subscribe((res) => {
      this.auctionCurrentState = res['auctionState'];
      if (this.auctionCurrentState) {
        let fragment = this.route.snapshot.fragment;
        this.bindDataToForm1();
        this.checkReadOnlyCatalog();
        if (fragment === 'check') {
          this.isUnpublishedLotNeeded = true;
        } else {
          this.checkLotsPublished();
          if (
            !this.auctionCurrentState.isActive &&
            !this.auctionCurrentState.isApproved
          ) {
            this.checkAuctionDeactivated();
          }
        }
      }
    });
  }

  private checkAuctionDeactivated() {
    if (
      this.auctionCurrentState.isSentForApproval &&
      this.auctionCurrentState.status === this.auctionStatuses.pending
    ) {
      this.isUnpublishedLotNeeded = true;
      return;
    }
    if (!this.auctionCurrentState.saleType.isCatalogReadOnly) {
      this.toastr.info(
        `Unfortunately ${this.auctionCode} is no longer available for bidding and you will be notified if and when the auction becomes available for bidding again`,
        constants.common.toast.infoTitle,
        constants.common.toast.config
      );
    }
    if (this.auctionCurrentState.saleType.isCatalogReadOnly) {
      this.toastr.info(
        `Unfortunately ${this.auctionCode} is deactivated and you will be notified if and when the auction becomes available again`,
        constants.common.toast.infoTitle,
        constants.common.toast.config
      );
    }
    this.router.navigateByUrl('/');
  }

  private checkReadOnlyCatalog() {
    this.readOnlyCatalog = this.auctionCurrentState.saleType.isCatalogReadOnly;
  }

  private getAuctionAnnouncement() {
    const auctionAnnouncement = this.announcementService
      .getAuctionAnnouncementByCode(this.auctionCode)
      .subscribe((res) => {
        this.auctionAnnouncement = res?.isActive ? res?.text : null;
      });
      this.subscriptions.push(auctionAnnouncement)
  }

  private bindDataToForm1() {
    this.isLoading = true;
    const auctionDetail = this.auctionService
      .getAuctionDetailByCode(this.auctionCode)
      .subscribe((res: any) => {
        this.auctionDetail = res;
        this.isLoading = false;
        this.getAuctionsLotData();
        this.getLotTypes();
        this.getLotCategories();
        this.getLotLocation();
        this.searchLot();
        this.checkLotConnectionMode();
      });
      this.subscriptions.push(auctionDetail)
  }

  filterModel() {
    return {
      auctionId: this.auctionDetail?.id,
      lotTypes: this.lotTypes,
      locations: this.locations,
      categories: this.categories,
      searchTerm: this.searchTerm,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortBy: this.sortBy,
      sortOrder: this.sortOrder,
      isPaginated: this.isPaginated,
      onlyActive: this.onlyActive,
      skipFeatured: !this.showFeaturedLots,
      isFromUrl: this.isUnpublishedLotNeeded,
    };
  }

  featuredLotButtonChange(isShow: any) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { featured: isShow },
      queryParamsHandling: 'merge',
      replaceUrl: true,
      preserveFragment: true,
    });
  }

  getAuctionsLotData() {
    if (!this.auctionDetail) return;
    this.showListing = false;
    this.isLoading = true;
    if (this.searchTerm == null) {
      this.searchTerm = '';
    }
    let model = this.filterModel();
    const allCurrentAuctionsLot = this.lotService.getAllCurrentAuctionsLots(model).subscribe(
      (res) => {
        this.showListing = true;
        this.auctionLotData = res.data;
        if (res.data.length > 0)
          this.userPaddleNumber =
            this.auctionLotData[0].loggedInUser?.paddleNumber;
        this.isLoading = false;
        this.totalAuctionLots = res.totalCount;
      },
      () => {
        this.showListing = false;
        this.isLoading = false;
      }
    );
    this.subscriptions.push(allCurrentAuctionsLot)
  }

  onPageChange(paging: number) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page: paging },
      queryParamsHandling: 'merge',
      replaceUrl: true,
      preserveFragment: true,
    });
  }

  onPageSizeChange(size: number) {
    this.pageSize = size;
    this.storage.storage.set('buyer-lot-catalog-page-size', size);
    this.getAuctionsLotData();
  }

  goToRegister(auctionCode: number) {
    this.router.navigate([auctionCode, routeTable.public.auctionRegister], {
      queryParams: { returnTo: this.router.url },
    });
  }

  getLotTypes() {
    const lotTypes = this.lotService.getLotTypesDropDownList().subscribe((res: any) => {
      this.lotTypesData = res;
    });
    this.subscriptions.push(lotTypes)
  }

  getLotCategories() {
    const lotCategories = this.lotService
      .getLotCategories(this.auctionDetail.id)
      .subscribe((res: any) => {
        this.lotCategoriesData = res;
      });
      this.subscriptions.push(lotCategories)
  }

  getLotLocation() {
    const lotLocation = this.lotService
      .getLotLocation(this.auctionDetail.id)
      .subscribe((res: any) => {
        this.lotLocationData = res;
      });
      this.subscriptions.push(lotLocation)
  }

  lotTypeFilter(value) {
    value = value == null ? 1 : value;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { type: value },
      queryParamsHandling: 'merge',
      replaceUrl: true,
      preserveFragment: true,
    });
  }

  categoryTypeFilter(value) {
    value = value == null ? '' : value;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { cat: value },
      queryParamsHandling: 'merge',
      replaceUrl: true,
      preserveFragment: true,
    });
  }

  locationTypeFilter(value) {
    value = value == null ? '' : value;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { loc: value },
      queryParamsHandling: 'merge',
      replaceUrl: true,
      preserveFragment: true,
    });
  }

  goToViewLotDetail(id) {
    this.router.navigate([id], {
      relativeTo: this.route,
      queryParams: { returnTo: this.router.url, preserveFragment: true },
    });
  }

  openHelpModal(template: TemplateRef<any>, helpTextId: number) {
    this.isLoading = true;
    let textId: number;
    if (helpTextId == this.helpTexts.catalogBidding)
      textId = this.cmsPages.helpTextCatalogWithBidding;
    if (helpTextId == this.helpTexts.readOnlyCatalog)
      textId = this.cmsPages.helpTextReadOnlyCatalog;
    const cmsPublic = this.cmsService.GetCmsPublic(textId).subscribe((res) => {
      this.helpTextData = res;
      this.isLoading = false;
      this.modalRef = this.modalService.show(
        template,
        Object.assign(
          {},
          {
            class:
              'custom-popup auction-help-modal modal-dialog modal-dialog-centered',
          }
        )
      );
    });
    this.subscriptions.push(cmsPublic)
  }

  resetSearch() {
    this.searchControl.reset();
  }

  private searchLot() {
    this.searchControl.valueChanges
      .pipe(debounceTime(1100))
      .subscribe((value) => {
        value = value == null ? '' : value;
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { term: value },
          queryParamsHandling: 'merge',
          replaceUrl: true,
          preserveFragment: true,
        });
      });
  }

  goBack() {
    this.router.navigate([this.auctionCode]);
  }

  downloadCSV() {
    let resArray: any = [];
    const downloadCSV = this.lotService.downloadCSV(this.auctionDetail.id).subscribe((res) => {
      resArray = JSON.parse(res);
      let data: any = [];
      resArray.forEach((element) => {
        var temp = [
          element.LotNumber,
          element.Description,
          element.Category,
          element.Location,
          new Date(element.LotStartTimeUtc).toDateString() +
            ' (' +
            element.TimeZoneName +
            ')',
          new Date(element.LotEndTimeUtc).toDateString() +
            ' (' +
            element.TimeZoneName +
            ')',
        ];
        data.push(temp);
      });
      var doc = new jsPDF();
      autoTable(doc, {
        head: [
          [
            'Lot Number',
            'Description',
            'Lot Category',
            'Location',
            'Start Date',
            'End Date',
          ],
        ],
        body: data,
      });
      doc.save(this.auctionDetail.title + 'catalog.pdf');
    });
    this.subscriptions.push(downloadCSV)
  }

  addToWatchList(lotId, lotNumber) {
    let model = {
      lotId: lotId,
      auctionId: this.auctionDetail.id,
    };
    const addToWatchList = this.watchListService.addToWatchList(model).subscribe(() => {
      this.toastr.success(
        `Lot # ${lotNumber} added to Watchlist`,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
      this.getAuctionsLotData();
    });
    this.subscriptions.push(addToWatchList)
  }

  removeFromWatchList(lotId, lotNumber) {
    let model = {
      lotId: lotId,
      auctionId: this.auctionDetail.id,
    };
    const removeWatchList = this.watchListService.removeFromWatchList(model).subscribe(() => {
      this.toastr.success(
        `Lot # ${lotNumber} removed from Watchlist`,
        constants.common.toast.successTitle,
        constants.common.toast.config
      );
      this.getAuctionsLotData();
    });
    this.subscriptions.push(removeWatchList)
  }

  /////// review bid section
  // get lot from lot-card component
  getSelectedLots(lotData: LotPublic | number) {
    this.featuredLotInfo = lotData;
    if (lotData > 0) {
      let index = this.selectedLotsForBulk.findIndex(
        (lot) => lot.id === (lotData as number)
      );
      if (index != -1) {
        this.selectedLotsForBulk.splice(index, 1);
      }
    } else {
      let index = this.selectedLotsForBulk.findIndex(
        (lot) => lot.id === (lotData as LotPublic).id
      );
      if (index == -1) {
        this.selectedLotsForBulk.push(lotData as LotPublic);
      } else {
        this.selectedLotsForBulk.splice(index, 1, lotData as LotPublic);
      }
    }
    this.isBulkBid = this.selectedLotsForBulk.length >= 1 ? true : false;
  }

  // check to open the review popup
  isBulkBidReview(value: boolean) {
    if (value) {
      this.createBulkBidModel();
      this.removedLotsFromBulkLot = [];
      this.modalRef = this.modalService.show(this.reviewModal, {
        class: 'custom-popup modal-dialog-centered',
        ignoreBackdropClick: true,
        keyboard: false,
      });
      this.modalRef.onHidden.subscribe(() => {
        this.changeInSelectedBulkLots = false;
      });
    }
  }

  // call API for submission
  submitBulkBid() {
    if (!this.selectedLotsForBulk.length) return;
    this.isLoading = true;
    let model = this.createBulkBidModel();
    this.showBulkSubmitBtn = false;
    const submitBid = this.bidService.submitPublicBulkBid(model).subscribe(
      (res: BulkBidSubmissionResult[]) => {
        this.isLoading = false;
        this.bulkBidSubmissionResult = res;
        if (res && res.length > 0) {
          if (res.every((i) => i.isSuccess)) {
            this.toastr.success(
              'Bid(s) Submitted Successfully',
              constants.common.toast.successTitle,
              constants.common.toast.config
            );
          }
          if (res.every((i) => i.isDeactivated)) {
            this.checkAuctionDeactivated();
          }
        }
        this.closeReviewModal();
        this.showBulkSubmitBtn = false;
      },
      (error) => {
        this.isLoading = false;
        this.showBulkSubmitBtn = false;
        this.submitBidError = error;
      }
    )
    this.subscriptions.push(submitBid)
  }

  // creating bulk model for submission API
  private createBulkBidModel(): BulkBid {
    let lotsToBeSubmit = this.selectedLotsForBulk
      .filter((val) => val.newBid >= val.nextRequiredBid)
      .map((val) => ({
        lotId: val.id,
        amount: val.newBid,
      }));

    this.showBulkSubmitBtn = lotsToBeSubmit.length > 0 ? true : false;

    return {
      auctionId: this.auctionDetail.id,
      lotAmount: lotsToBeSubmit,
      userId: this.loggedInUser,
      paddleNumber: this.userPaddleNumber,
      proxyUserId: null,
    };
  }

  // remove lot logic
  removeLotFromReviewBids(index: number) {
    this.removedLotsFromBulkLot.push(
      this.selectedLotsForBulk.splice(index, 1)[0]
    );
  }

  closeReviewModal() {
    this.showBulkSubmitBtn = true;
    this.changeInSelectedBulkLots = false;
    this.submitBidError = null;
    if (this.removedLotsFromBulkLot.length) {
      this.bulkBidSubmissionResult = this.createRemovedLotModel();
    }
    if (this.modalRef) this.modalRef.hide();
  }

  // we will send this model only when review modal close so that entered values removed from the lot
  private createRemovedLotModel(): BulkBidSubmissionResult[] {
    let removeLotResult: BulkBidSubmissionResult[];
    let addedLotResult: BulkBidSubmissionResult[];

    let lotIds: number[] = this.bulkBidSubmissionResult?.map((it) => it.lotId);

    /* this block will only be work if bulkBidSubmissionResult has API data otherwise
     else block work where we simply tells the which lot is removed from the current selected lot
    */
    if (
      lotIds &&
      lotIds.length &&
      this.bulkBidSubmissionResult.every(
        (it) => it.bidStatus > 0 && it.bidStatus != null
      )
    ) {
      removeLotResult = this.removedLotsFromBulkLot.map((it) => {
        if (!lotIds.includes(it.id)) {
          return {
            isRemoved: true,
            lotId: it.id,
          };
        }
      });
      return this.bulkBidSubmissionResult.concat(removeLotResult);
    } else {
      removeLotResult = this.removedLotsFromBulkLot.map((it) => ({
        isRemoved: true,
        lotId: it.id,
      }));
      addedLotResult = this.selectedLotsForBulk.map((it) => ({
        isRemoved: false,
        lotId: it.id,
      }));
      return removeLotResult.concat(addedLotResult);
    }
  }

  checkLotsPublished() {
    let isLotsPublishedFlag = this.auctionCurrentState.isInHouseLotConfigured;
    if (
      this.auctionCurrentState.isSentForApproval &&
      this.auctionCurrentState.status === this.auctionStatuses.pending
    ) {
      return;
    }
    if (!isLotsPublishedFlag) this.goBack();
  }

  // WebSocket Logic comes here
  // single websocket connection will handle latest data for each lot card
  buildConnection() {
    this.lotHubConnection = new HubConnectionBuilder()
      .configureLogging(LogLevel.Debug)
      .withUrl(this.hubUrl)
      .withAutomaticReconnect([2000, 4000])
      .build();

    this.registerHubEvents();

    this.startConnection();
  }

  startConnection() {
    this.lotHubConnection
      .start()
      .then(() => {
        this.isConnectionClosing = false;
        this.loader = false;
        this.isLotConnected = true;
        this.isLowConnectionMode = false;
        this.getLotData();
      })
      .catch(() => {
        this.isConnectionClosing = true;
        this.loader = false;
        this.isLotConnected = false;
        this.isLowConnectionMode = true;
      });
  }

  registerHubEvents() {
    this.lotHubConnection.onreconnecting(() => {
      this.isConnectionClosing = false;
      this.loader = false;
      this.isLotConnected = false;
      this.isLowConnectionMode = true;
    });

    this.lotHubConnection.onreconnected(() => {
      this.isConnectionClosing = false;
      this.loader = false;
      this.isLotConnected = true;
      this.isLowConnectionMode = false;
      this.getLotData();
    });

    this.lotHubConnection.onclose(() => {
      this.isConnectionClosing = true;
      this.loader = false;
      this.isLowConnectionMode = true;
      if (!this.isLotConnected) this.buildConnection();
    });

    this.biddingListener();
  }

  getLotData() {
    if (!this.isLowConnectionMode) this.loader = true;
    let groupName: string = this.auctionDetail.id + '#';
    this.lotHubConnection
      .invoke('AddUserToLotBidding', groupName)
      .then(() => {
        this.loader = false;
      })
      .catch(() => {
        this.loader = false;
      });
    this.getServerCurrentDatetime();
  }

  biddingListener() {
    this.lotHubConnection.on('GetLotByGroupName', (data) => {
      if (data) {
        this.checkOpenedBulkLotPresentInRealTimeData(data);
        this.sendLotDataToLotCard = data;
      }
    });
  }

  getServerCurrentDatetime() {
    this.serverTimeSubcription = interval(10000).subscribe(() => {
      this.lotHubConnection.invoke('ServerCurrentDateTime').then((response) => {
        this.sendTimerToLotCard = response;
      });
    });
  }

  ngOnDestroy() {
    if (this.serverTimeSubcription) this.serverTimeSubcription.unsubscribe();
    if (this.isLotConnected) {
      this.lotHubConnection.stop().then(() => {
        console.log('Connection successfully stopped');
      });
    }
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });

  }

  // check realtime data having ids and amount changes in selected bulk lot popup
  checkOpenedBulkLotPresentInRealTimeData(realTimeData) {
    if (this.selectedLotsForBulk && this.selectedLotsForBulk?.length) {
      let ids = this.selectedLotsForBulk.map((it) => it.id);
      if (ids.includes(realTimeData?.lotId)) {
        this.changeInSelectedBulkLots = true;
      } else this.changeInSelectedBulkLots = false;
    }
  }

}
